import React from 'react';
import { PageContent, PageElement, UtilsBlock, TextRegular, Icon } from '@hz-design-system/web-ui';
import { Trans, useI18nContext } from '@ecg-internal/js-react-i18n';

import SellBlock from '../../SellBlock/components/SellBlock';
import { EnvironmentProvider } from '../../../contexts/EnvironmentContext';
import SellSteps from './SellSteps';
import SellValueChecker from './SellValueChecker';
import SellReasons from './SellReasons';
import SellTips from './SellTips';
import SellNudge from './SellNudge';
import SellFaqList from '../../SellFaqList/SellFaqList';
import SellLocations from './SellLocations';
import Classes from './SellPageContent.module.scss';
import { TEnvConfigCars } from 'types/TServerContext';
import SellBreadcrumbs from './SellBreadcrumbs';

type TSellPageContentProps = {
  environment: TEnvConfigCars;
  appState: any;
};

const SellPageContent = ({ environment, appState }: TSellPageContentProps) => {
  const { t } = useI18nContext();
  const {
    tenantContext: { tenant },
    experiments: { isCarsSellPageEnabled, isCarsSellLocationPagesEnabled },
  } = environment;
  const intent = environment.intent as string;
  const { location } = appState;
  const isMp = tenant === 'mp';

  // {location ? t('cars.page.sell.location.h1', { location: location.name }) : t('page.title.sell.cars')}

  return (
    <EnvironmentProvider value={environment}>
      {/* @ts-expect-error -- DS issue with id */}
      <PageElement className={Classes.heroSection} id="check-de-dagwaarde">
        <PageContent className={Classes.hero}>
          <div className={Classes.heroContent}>
            <UtilsBlock as="h1" textStyle={['title-2', null, 'title-1']}>
              <span className={Classes.heroHeaderLine}>{t(`page.title.${intent}.line1`)}</span>
              <span className={Classes.heroHeaderLine}>{t(`page.title.${intent}.line2`)}</span>
            </UtilsBlock>
            <TextRegular className={Classes.pageSubtitle}>{t(`page.subtitle.${intent}`)}</TextRegular>
            <ul className={Classes.heroUsps}>
              <li className={Classes.heroUsp}>
                <Icon className={Classes.heroUspIcon} name="profile" color="text-brand-primary" />
                <Trans tagName="span" i18nKey={appState.usps[0].key} />
              </li>
            </ul>
          </div>
          <div className={`${Classes.heroSell} PageContent-card`}>
            <SellBlock withLicensePlateField={appState.withLicensePlateField} />
          </div>
        </PageContent>
      </PageElement>
      {isCarsSellPageEnabled && isMp && (
        <>
          <PageElement kind="full-width">
            <PageContent className={Classes.contentSection}>
              <SellSteps />
            </PageContent>
          </PageElement>
          <PageElement>
            <PageContent className={Classes.carouselSection}>
              <SellValueChecker />
            </PageContent>
          </PageElement>
          <PageElement>
            <PageContent className={Classes.carouselSection}>
              <SellReasons />
            </PageContent>
          </PageElement>
          <PageElement kind="full-width">
            <PageContent className={Classes.contentSection}>
              <SellTips />
            </PageContent>
          </PageElement>
          <PageElement kind="full-width">
            <PageContent className={Classes.contentSection}>
              <SellFaqList />
            </PageContent>
          </PageElement>
        </>
      )}
      <PageElement kind="full-width">
        <PageContent className={Classes.contentSection}>
          <SellNudge withPriceCheckLink={appState.withLicensePlateField} />
        </PageContent>
      </PageElement>
      <PageElement kind="full-width">
        <PageContent className={Classes.contentSection}>
          <SellBreadcrumbs />
          {isCarsSellLocationPagesEnabled && isMp && !location && <SellLocations />}
        </PageContent>
      </PageElement>
    </EnvironmentProvider>
  );
};

export default SellPageContent;
